import { render, staticRenderFns } from "./kycUpload.vue?vue&type=template&id=35699a16&scoped=true&"
import script from "./kycUpload.vue?vue&type=script&lang=js&"
export * from "./kycUpload.vue?vue&type=script&lang=js&"
import style0 from "./kycUpload.vue?vue&type=style&index=0&id=35699a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35699a16",
  null
  
)

export default component.exports